import { FormEntryWithState } from '@imbox/form-renderer/lib/types/form-entry'
import * as React from 'react'
import { ArticleLink } from '../../components/answers/articleLink'
import { Category } from '../../components/answers/category'
import { PopularQuestions } from '../../components/answers/popularquestions'
import { SearchField } from '../../components/answers/searchfield'

export function getAnswerCustomFormField(
  userId: number,
  formId: number,
  formField: FormEntryWithState,
  index: number
): React.ReactNode {
  switch (formField.field_type) {
    case 'searchField':
      return (
        <div className='col-xs-12' key={index}>
          <SearchField
            userId={userId}
            answersId={formId}
            shouldShowResults
            shouldShowSuggestions
          />
        </div>
      )
    case 'popularQuestions':
      return (
        <PopularQuestions
          numberOfItems={formField.numbItems}
          categoryIds={formField.cats}
          key={index}
        />
      )
    case 'categoryQuestions':
      return <Category field={formField} key={index} />
    case 'articleLink':
      return <ArticleLink field={formField} key={index} />
  }
}
